module.exports = __webpack_public_path__ + "img/frontdesklessrounded.8ce4ad0e.webp";